import React from 'react';
import { Collapse } from 'antd';
import { I18n } from '@aws-amplify/core';
import { LabelMediumRegular } from '@/components/Settings/DataExtraction/styles';
import * as S from './styles';

interface CollapseFilterProps {
	isOpen?: boolean;
	children?: JSX.Element;
}

const { Panel } = Collapse;

export function CollapseFilter({ isOpen = false, children }: Readonly<CollapseFilterProps>): JSX.Element {
	const defaultActiveKey: string = isOpen ? '1' : '0';
	return (
		<S.CollapseWrapper defaultActiveKey={defaultActiveKey}>
			<Panel key="1" header={<LabelMediumRegular>{I18n.get('Filter')}</LabelMediumRegular>}>
				{children}
			</Panel>
		</S.CollapseWrapper>
	);
}
